module.exports = __webpack_public_path__ + "img/galerie-24.074abd86.jpg";